export const PaymentMethodRequiredMessages = {
    title: 'Payment Method Required',
    content:
        'Please select a payment method for this order. If you do not have a payment method on file, please add one.',
    primaryAction: {
        title: 'OK',
        name: 'confirm',
    },
} as const;
